export interface HeidiMessageReady {
  type: "HEIDI_READY";
}

export interface HeidiMessageSessionStarted {
  type: "HEIDI_SESSION_STARTED";
  payload?: { data?: string };
}

export interface HeidiMessageOpen {
  type: "HEIDI_OPEN";
  payload?: { data?: string };
}

export interface HeidiMessageResize {
  type: "HEIDI_RESIZE";
  payload?: { data?: string | boolean };
}

export interface HeidiMessagePushData {
  type: "HEIDI_PUSH_DATA";
  payload?: { data?: string };
}

export interface HeidiMessageClose {
  type: "HEIDI_CLOSE";
}

export type HeidiMessage =
  | HeidiMessageReady
  | HeidiMessageSessionStarted
  | HeidiMessageOpen
  | HeidiMessageResize
  | HeidiMessagePushData
  | HeidiMessageClose;

export interface MHeidiRecorderProps {
  src?: string;
  expandedHeight?: number;
  collapsedHeight?: number;
  width?: string;
  iframeId?: string;
}

export const mpfHeidiRecorderDefaults: Required<MHeidiRecorderProps> = {
  src: "",
  expandedHeight: 500,
  collapsedHeight: 220,
  iframeId: "heidi-component-iframe",
};
